import React from 'react';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import firebase from "../../firebase/firebase";
import {BarChart} from "./line-chart";


export default function UserAnalytics(){
  const [stats, setStats] = React.useState({
    admin: 0,
    investor: 0,
    creator: 0,
    artist: 0,
  })
  const loadData = () => new Promise(async (resolve, reject) => {
    const statsRef = firebase.firestore().collection('stats');
    try {
      const sts = await statsRef
        .get()
      setStats({

        creator: sts.docs[0].data().creator,
        investor: sts.docs[0].data().investor,
        artist: sts.docs[0].data().artist,
        admin: sts.docs[0].data().admin,
      })
      resolve('all done')
    } catch (e) {
      reject(e)
    }
  })
  React.useEffect(() => {
     loadData()
  }, [])
 /* React.useEffect(() => {
    let unsubs ;
    const usersRef = firebase.firestore().collection('users');
    unsubs = usersRef.where('userType', '==', 'admin').onSnapshot((d) => {
      console.log(d.size)
      setStats({...stats, admin: d.size})
    })
  })
  React.useEffect(() => {
    let unsubs ;
    const usersRef = firebase.firestore().collection('users');
    unsubs = usersRef.where('userType', '==', 'creator').get().then((d) => {
      console.log(d.size)
      setStats({...stats, creator: d.size})
    })
  })
  React.useEffect(() => {
    let unsubs ;
    const usersRef = firebase.firestore().collection('users');
    unsubs = usersRef.where('userType', '==', 'investor').get().then((d) => {
      console.log(d.size)
      setStats({...stats, investor: d.size})
    })
  })
  React.useEffect(() => {
    let unsubs ;
    const usersRef = firebase.firestore().collection('users');
    unsubs = usersRef.where('userType', '==', 'artist').get().then((d) => {
      console.log(d.size)
      setStats({...stats, artist: d.size})
    })
  })*/
  return (
    <Container maxWidth={'full-width'}  sx={{height: 'calc(100vh - 120px)', p: 5, textAlign: 'left',overflowY: 'scroll'}}>
      <Stack direction={'column'} spacing={5}>

        <Typography variant={'h4'} color={'primary'}>
          User Analytics
        </Typography>
        <Grid container>
          <Grid xs={2} sx={{ backgroundColor:'#E3E8F0', mr:2}}
          >
            <Stack
              direction="column"
              justifyContent="center"
              alignItems="center"
              sx={{width:'100%', height: 250,}}
            >
              <Typography variant={'h2'} color={'primary'} fontSize={'48px'} >
                {stats?.creator}
              </Typography>

              <Typography  color={'primary'} fontSize={'24px'}>
                Creators
              </Typography>
            </Stack>

          </Grid>
          <Grid xs={2} sx={{ backgroundColor:'#E3E8F0', mr:2}}
          >
            <Stack
              direction="column"
              justifyContent="center"
              alignItems="center"
              sx={{width:'100%', height: 250,}}
            >
              <Typography variant={'h2'} color={'primary'} fontSize={'48px'}>
                {stats?.investor}
              </Typography>

              <Typography  color={'primary'} fontSize={'24px'}>
                Investors
              </Typography>
            </Stack>

          </Grid>
          <Grid xs={2} sx={{ backgroundColor:'#E3E8F0', mr:2}}
          >
            <Stack
              direction="column"
              justifyContent="center"
              alignItems="center"
              sx={{width:'100%', height: 250,}}
            >
              <Typography variant={'h2'} color={'primary'} fontSize={'48px'}>
                {stats?.artist}
              </Typography>

              <Typography  color={'primary'} fontSize={'24px'}>
                Artists
              </Typography>
            </Stack>

          </Grid>
          <Grid xs={2} sx={{ backgroundColor:'#E3E8F0', mr:2}}
          >
            <Stack
              direction="column"
              justifyContent="center"
              alignItems="center"
              sx={{width:'100%', height: 250,}}
            >
              <Typography variant={'h2'} color={'primary'} fontSize={'48px'}>
                {stats?.admin}
              </Typography>

              <Typography  color={'primary'} fontSize={'24px'}>
                Admin
              </Typography>
            </Stack>

          </Grid>
        </Grid>

        <BarChart da={stats}/>
      </Stack>


    </Container>
  )
}